import { useEffect } from "react";
import { useParams } from "react-router-dom";

// Single source of truth for the deployed Edge Function that handles device
// detection, click logging, and the store redirect.
export const INFLUENCER_REDIRECT_URL =
  "https://ciytwbkjgesbdjzegbxr.supabase.co/functions/v1/influencer-redirect";

// Fallback for /r/:tag when the Apache .htaccess rule is NOT in effect — e.g.
// local `npm start`, or a host that didn't pick up public/.htaccess.
//
// In production, public/.htaccess 302-redirects /r/<tag> at the server BEFORE
// the React bundle ever loads. That server-side redirect is what preserves the
// visitor's real IP + User-Agent for the Edge Function (critical for iOS
// attribution), so this component normally never mounts. When it does, it still
// does a full-page navigation (window.location.replace) — NOT a fetch/proxy —
// so the browser hits the function directly.
const InfluencerRedirect = () => {
  const { tag } = useParams();

  useEffect(() => {
    if (!tag) return;
    window.location.replace(
      `${INFLUENCER_REDIRECT_URL}?ref=${encodeURIComponent(tag)}`
    );
  }, [tag]);

  return null;
};

export default InfluencerRedirect;
